<template>
  <div>
    <v-toolbar dense color="primary" dark flat>
      <v-row class="mt-10">
        <v-col>
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="computedFromDate"
                label="From"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              no-title
              v-model="fromDate"
              @input="menu = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col>
          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="computedToDate"
                label="To"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              no-title
              v-model="toDate"
              @input="menu2 = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col>
          <v-btn
            @click="fillData"
            color="white"
            outlined
            small
            :loading="loading"
          >
            Refresh <v-icon right>mdi-refresh-circle</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-toolbar>
    <v-row>
      <v-col cols="12">
        <apexchart
          type="area"
          height="400"
          :options="chartOptions"
          :series="series"
        ></apexchart>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: ["chartData"],
  name: "Dashboard",
  data() {
    return {
      loading: false,
      series: [],
      chartOptions: {},
      fromDate: moment()
        .subtract(7, "days")
        .format("YYYY-MM-DD"),
      toDate: moment()
        .add(1, "days")
        .format("YYYY-MM-DD"),
      menu: false,
      menu2: false,
    };
  },
  watch: {
    chartData() {
      this.fillData();
    },
  },
  mounted() {
    this.fillData();
  },
  computed: {
    computedFromDate() {
      return this.fromDate ? moment(this.fromDate).format("DD/MM/yyyy") : "";
    },
    computedToDate() {
      return this.toDate ? moment(this.toDate).format("DD/MM/yyyy") : "";
    },
  },
  methods: {
    fillData() {
      this.loading = true;

      const Temp = new Array();
      const Humidity = new Array();
      const Pressure = new Array();
      const date = new Array();

      const fromDate = moment(this.fromDate).format("X");
      const toDate = moment(this.toDate).format("X");

      const dataValues = this.chartData.filter((item) => {
        var date = item.TimeUnix;
        return date >= fromDate && date <= toDate;
      });

      dataValues.forEach((element) => {
        Temp.push(element.Temp);
        Humidity.push(element.Humidity);
        Pressure.push(element.Pressure);
        date.push(element.TimeUnix);
      });

      this.series = [
        {
          name: "Temperature",
          data: Temp,
        },
        {
          name: "Humidity",
          data: Humidity,
        },
      ];

      this.chartOptions = {
        chart: {
          height: 400,
          type: "area",
          foreColor: "#ffffff",
          toolbar: {
            show: false,
            offsetX: 0,
            offsetY: 0,
            tools: {
              download: false,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false | '<img src="/static/icons/reset.png" width="20">',
              customIcons: [],
            },
            autoSelected: null,
          },
        },
        colors: ["#7400b8", "#80ffdb"],
        stroke: {
          width: 7,
          curve: "smooth",
        },
        xaxis: {
          type: "timestamp",
          categories: date,
          labels: {
            rotate: -15,
            rotateAlways: true,
            formatter: (date) => {
              return moment.unix(date).format("Do MMM @ h:mm a");
            },
          },
        },
        legend: {
          position: "bottom",
        },
        dataLabels: {
          enabled: false,
        },
        grid: {
          show: false,
        },
      };

      setTimeout(() => {
        this.loading = false;
      }, 1000);
    },
  },
};
</script>
